module.exports = __webpack_public_path__ + "img/info_game.30214645.jpg";